import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent, IsRowSelectable } from "ag-grid-community";
import { ProductService } from "src/app/services/products.service";
import { VendorService } from "src/app/services/vendor.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NetworkService } from "src/app/services/network.service";
import { GeoService } from "src/app/services/geo.service";
import Swal from "sweetalert2";
import { CompanyService } from "src/app/services/company.service";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, lastValueFrom, map } from "rxjs";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { SalesInvoiceService } from "src/app/services/misc/sales/sales.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { AWBDeleteActionsRenderer } from "../../../shared/ag-grid/cell-renderers/awb-delete.component";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'app-edit-invoice',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss']
})
export class SalesInvoiceEditComponent implements OnInit, AfterViewInit {
    invoiceForm: FormGroup;
    awbForm: FormGroup;
    isFormSubmitted = false;
    isAWBFormSubmitted = false;
    customerList: any[];
    productList: any[];
    vendorList: any[];
    filteredProductList: any[];
    financialyearList = [{ id: 1, name: '2024-01-19' }];
    defaultType: any;
    activeId: any;
    context: any;
    //AWBListDB : any[] = [];
    allAWBList: any[] = [];
    singleAWBList: any[] = [];
    //customer: any[] = [];
    selectedCustomer: any;
    filteredCustomer = [];
    allCustomerCounts: any = [];
    AllCustomerCount: any = [];
    ServiceCenterOptions: [];
    productTypeList = [{ name: 'Domestic' }, { name: 'International' }, { name: 'Import' }];
    serviceList: any[] = [];
    originCityList: any[] = [];
    destinationCityList: any[] = [];
    countryCode: any;
    countryList: any[] = [];
    destinationStateList: any[] = [];
    originStateList: any[] = [];
    dropDownSettings = {};
    enabledAWB = false;
    addressBookList: any[] = [];
    paymentOptions: any[] = [{ name: 'Credit' }, { name: 'Cash' }, { name: 'COD' }];
    configList: any;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
      };
      

    companyList: any[];
    serviceCenterCountry: string;
    serviceCenterState: string;
    invoiceId: number;
    private gridApi!: GridApi;
    private gridApi2!: GridApi;
    private gridColumnApi!: ColumnApi;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        domLayout: "autoHeight"
    };
    rowDataCustWise: any[] = []
    rowDataAWBWise: any[] = []
    showServiceCenter: any;
    isLock = false;
    areSelected = false;

    gridOptions: GridOptions = {
        rowSelection: 'multiple',
        pagination: true,
        paginationPageSize: 10,
        suppressRowClickSelection: false,
        domLayout: "autoHeight"
    }

    columnDefsAWBWise = [
        {
            headerName: '', field: 'isAWBWise',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            sortable: false,
            filter: false,
            maxWidth: 60,
            pinned: 'left'
        },
        { headerName: 'AWB No.', field: 'awbnumber', minWidth: 140, pinned: 'left' },
        { headerName: 'Date', field: 'Date', minWidth: 100 },
        { headerName: 'Consignee', field: 'ConsigneeName', minWidth: 240 },
        { headerName: 'Pieces', field: 'pieces', minWidth: 90 },
        { headerName: 'Weight', field: 'weight', minWidth: 90 },
        { headerName: 'Freight', field: 'freight', minWidth: 90 },
        { headerName: 'Other', field: 'othercharges', minWidth: 90 },
        { headerName: 'Sub Total', field: 'amount', minWidth: 110 },
        { headerName: 'Fuel', field: 'totalfuel', minWidth: 90 },
        { headerName: 'IGST', field: 'igst', minWidth: 90 },
        { headerName: 'CGST', field: 'csgt', minWidth: 90 },
        { headerName: 'SGST', field: 'sgst', minWidth: 90 },
        { headerName: 'Grand Total', field: 'grandTotal', minWidth: 120, pinned: 'right' },
        {
            headerName: 'Action',
            cellRenderer: AWBDeleteActionsRenderer,
            cellClass: "actions-button-cell",
            minWidth: 80,
            pinned: 'right'
        },
    ];

    useEnterKey = false;

    constructor(
        private formBuilder: FormBuilder,
        private appCoreService: AppCoreService,
        private vendorService: VendorService,
        private productService: ProductService,
        private serviceCenter: NetworkService,
        //private ngxLoaderService: NgxUiLoaderService,
        private invoiceService: SalesInvoiceService,
        private geoService: GeoService,
        private router: Router,
        private companyService: CompanyService,
        private addressbookService: AddressBookService,
        private route: ActivatedRoute,
        private rateService: RateUploadService,
        private configsService: ConfigService,
        private ngxLoaderService: NgxUiLoaderService,
        private titleService: Title,
        private utilities: Utilities,
        private toastr: ToastrService,
    ) {
        titleService.setTitle('Sales');
        this.context = {
            componentParent: this,
            componentName: 'SalesInvoiceEditComponent',
            actionConfig: {
                delete: true
            }
        };
    }
    currentDate = this.formateDate(new Date()).dateString;

    async ngOnInit() {
        this.invoiceId = this.route.snapshot.params['id'];
        this.invoiceForm = this.formBuilder.group({
            //selectionSwitch: ['single'],
            ddlCompany: [{ disabled: true, value: null }],
            txtFromDate: [{ disabled: true, value: null }],
            txtToDate: [{ disabled: true, value: this.currentDate }],
            txtInvoiceDate: [{ disabled: false, value: this.currentDate }],
            txtInvoiceNo: [{ disabled: true, value: null }],
            ddlProduct: [{ disabled: true, value: null }],
            ddlVendor: [{ disabled: true, value: null }],
            ddlVendorService: [{ disabled: true, value: null }],
            txtShipper: [{ disabled: true, value: null }],
            ddlServiceCenter: [{ disabled: true, value: null }],
            ddlProductType: [{ disabled: true, value: null }],
            ddlPaymentType: [{ disabled: true, value: null }],
            ddlCustomer: [{ disabled: true, value: null }],
            ddlOriginCountry: [{ disabled: true, value: null }],
            ddlOriginState: [{ disabled: true, value: null }],
            ddlOriginCity: [{ disabled: true, value: null }],
            ddlDestinationCountry: [{ disabled: true, value: null }],
            ddlDestinationState: [{ disabled: true, value: null }],
            ddlDestinationCity: [{ disabled: true, value: null }],
            txtAwbNo: [{ disabled: true, value: null }],
            txtCustomer: [{ disabled: true, value: null }],
        });

        this.awbForm = this.formBuilder.group({
            txtType: ['AWB'],
            txtAWBNo: [null, Validators.required],
            txtFromDate: [null],
            txtToDate: [null]
        });

        this.awbForm.get('txtType').valueChanges.subscribe(type => {
            this.isAWBFormSubmitted = false;
            if (type === 'AWB') {
                this.awbForm.get('txtAWBNo').setValidators([Validators.required]);
                this.awbForm.get('txtFromDate').clearValidators();
                this.awbForm.get('txtToDate').clearValidators();
            } else if (type === 'DateRange') {
                this.awbForm.get('txtAWBNo').clearValidators();
                this.awbForm.get('txtFromDate').setValidators([Validators.required]);
                this.awbForm.get('txtToDate').setValidators([Validators.required]);
            }
            this.awbForm.get('txtAWBNo').updateValueAndValidity();
            this.awbForm.get('txtFromDate').updateValueAndValidity();
            this.awbForm.get('txtToDate').updateValueAndValidity();
        });

        this.checkPermission();
        // this.getAllCustomers();
        // this.getAllServiceCenter();
        // this.bindCountries();
        // this.bindProduct();
        // this.bindVendor();
        await this.getAllCompanies();
        // this.bindAddressBook();
        this.getById(this.invoiceId);
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.invoiceForm) : null;
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        // const permission = userData.config.filter(x => x.categoryname === 'InvoiceSeries');
        const permission = userData.config.filter(x => x.categoryname === 'Sales');
        if (permission.length) {
          this.permConfig.isViewAllowed = permission[0].view;
          this.permConfig.isAddAllowed = permission[0].add;
          this.permConfig.isEditAllowed = permission[0].edit;
          this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    getById(id: number) {
        this.ngxLoaderService.start();
        this.invoiceService.GetById(id).subscribe(res => {
            if (res && res.success) {
                this.ngxLoaderService.stop();
                const resData = res.data[0];
                this.isLock = resData.islock || false;
                // assign row to view only or not
                this.context.actionConfig.delete = !this.isLock;
                this.invoiceForm.patchValue({
                    txtFromDate: this.formateDate(resData.invoicestartdate).dateString,
                    txtToDate: this.formateDate(resData.invoiceenddate).dateString,
                    txtInvoiceNo: resData.invoicenofull,
                    txtInvoiceDate: this.formateDate(resData.invoicedate).dateString,
                    ddlServiceCenter: resData.servicecenterid,
                    ddlProductType: resData.producttype,
                    ddlPaymentType: resData.paymenttype,
                    ddlCustomer: resData.customerid,
                    txtShipper: resData.shippername,
                    ddlProduct: resData.productid,
                    ddlVendor: resData.vendorid,
                    ddlVendorService: resData.serviceid,
                    ddlOriginCountry: resData.origincountryisocode,
                    ddlOriginState: resData.originstateisocode,
                    ddlOriginCity: resData.origincityisocode,
                    ddlDestinationCountry: resData.origincountryisocode,
                    ddlDestinationState: resData.originstateisocode,
                    ddlDestinationCity: resData.origincityisocode,
                    ddlCompany: resData.companyid
                });
                this.getAllFilteredAwbno();
            }
        })
    }


    getAllFilteredAwbno() {
        // if (changeFieldType === 'fromDate' || changeFieldType === 'toDate') {
        //     this.loadDefaultValues()
        // }
        this.invoiceForm.get('txtCustomer').setValue(null);

        this.rowDataCustWise = [];
        this.rowDataAWBWise = [];

        try {
            this.invoiceService.GetAWBListByInvoiceId({ invoiceid: this.invoiceId, mode: 'edit' }).subscribe((res) => {
                if (res && res.success) {
                    this.allAWBList = res.data;
                    //this.customer = this.allAWBList.map(item => item.customerid).filter((value, index, self) => self.indexOf(value) === index)
                    let filteredCust: any[] = [];

                    this.allAWBList.filter((a, i) => this.allAWBList.findIndex((s) => a.customerid === s.customerid) === i).map((x) => {
                        filteredCust.push({
                            id: x.customerid,
                            name: x.customername
                        });
                    });
                    //console.log("filteredCust", filteredCust);
                    this.filteredCustomer = [...filteredCust];
                    if (this.filteredCustomer.length) {
                        this.invoiceForm.get('txtCustomer').setValue(this.filteredCustomer[0].name);
                        this.showDataAWBWise();
                    }
                }
            })
        } catch (e) {
            console.log(e);
        }
    }

    // getAllCustomers() {
    //     try {
    //       this.customerService.GetAll({scid: this.appCoreService.GetUserData().selectedServiceCenter}).subscribe((res) => {
    //         if (res) {
    //           this.customerList = res.data;
    //         }
    //       })
    //     } catch (error) {
    //       console.error(error);
    //     }
    //   }

    showDataAWBWise() {
        let customerAWBList: any = [];
        customerAWBList = [];
        this.rowDataAWBWise = [];

        let customers: any[] = this.filteredCustomer;

        if (customers?.length) {
            customerAWBList = this.allAWBList.filter(x => x.customerid == customers[0].id);
            customerAWBList.forEach((keys: any, vals: any) => {
                // shipmentAmount = parseInt(keys.shipmentvalue) + shipmentAmount;
                let obj1 = {
                    customerid: this.filteredCustomer[0].id,
                    awbnumber: keys.awbnumber,
                    Date: keys.bookingdate,
                    ConsigneeName: keys?.consigneename,
                    pieces: keys.pieces ?? 0,
                    weight: keys.actualweight ?? 0,
                    amount: !isNaN(parseFloat(keys.amount)) ? parseFloat(keys.amount) : 0,
                    freight: !isNaN(parseFloat(keys.freight)) ? parseFloat(keys.freight) : 0,
                    othercharges: !isNaN(parseFloat(keys.othercharges)) ? parseFloat(keys.othercharges) : 0,
                    totalfuel: !isNaN(parseFloat(keys.totalfuel)) ? parseFloat(keys.totalfuel) : 0,
                    igst: !isNaN(parseFloat(keys.tax?.igst)) ? parseFloat(keys.tax?.igst) : 0,
                    csgt: !isNaN(parseFloat(keys.tax?.cgst)) ? parseFloat(keys.tax?.cgst) : 0,
                    sgst: !isNaN(parseFloat(keys.tax?.sgst)) ? parseFloat(keys.tax?.sgst) : 0,
                    grandTotal: !isNaN(parseFloat(keys.totalamount)) ? parseFloat(keys.totalamount) : 0,
                    isaddednewly: keys.isaddednewly ?? false
                };
                this.rowDataAWBWise.push(obj1);

            });
        }
    }

    async applyRates() {
        const selectedRows = this.gridApi2.getSelectedRows();
        if (selectedRows.length) {
            try {
                this.rateService.getCountById(this.invoiceId).subscribe(async res => {
                    if (res?.success) {
                        const invoiceCount = res.data[0].invoicecount;
                        const sysConfigCount = res.data[0].sysconfigcount;
                        const result = res.data[0].result;
                        // console.log("invoiceCount ", invoiceCount, "\nsysConfigCount", sysConfigCount,"\nresult",result);
                        if (result === true) {
                            this.openConfirmationDialog(`<span>Do you want to update</span><b> Rates </b><span>in below entries ?</span>`, (confirmed: any) => {
                                if (confirmed) {
                                    const selectedRows = this.gridApi2.getSelectedRows();
                                    const awbArrays: any[] = selectedRows.map(x => x.awbnumber);
                                    let req = {
                                        awbList: awbArrays,
                                        rateupdatetype: "Customer"
                                    }
                                    this.rateService.UpdateRates(req).subscribe(res => {
                                        if (res && res.success) {
                                            this.updateCountByInvoiceId(this.invoiceId);
                                            this.appCoreService.showMessage('Rates Applied Sucessfully.', 'Success', 'success');
                                            this.router.navigate(['/invoices/sales']);
                                        }
                                    })
                                }
                            });

                        }
                        else if (result === false) {
                            this.openWarningDialog("Rate update limit exceeds, not allow to update rate on this invoice");
                        }
                        else (
                            this.appCoreService.showMessage("Something Went Wrong !!,\nPlease Contact to Administrator !!", 'Warning', 'warning')
                        )
                    }
                });
            } catch (e) {
                console.error(e);
            }
        }
        else
            this.appCoreService.showMessage('Please Select AirWay Bill to apply rate.', 'Warning', 'warning');
    }

    updateCountByInvoiceId(invoiceid: any) {
        try {
            this.rateService.updateCount(invoiceid).subscribe(res => {
                if (res?.success) {
                    console.log(" Successfully Updated the count ")
                }
            });
        } catch (e) {
            console.error(e);
        }
    }


    // ----------------------*------------------------
    bindProduct() {
        this.productService.GetAll('').subscribe((res) => {
            this.productList = res?.success ? res.data : [];
        })
    }

    async getAllCompanies() {
        try {
            const res = await lastValueFrom(this.companyService.GetAll());
            if (res && res.success) {
                this.companyList = res.data;
                //select default
                // const defaultcompany = this.companyList.filter(x => x.isdefault);
                // defaultcompany ? this.invoiceForm.get('ddlCompany').setValue(defaultcompany[0].id) : null;
                //if billto company then show service center
                //this.showServiceCenter = defaultcompany[0].billto == 'Service Center' ? true : false;
                this.onChangeCompany();
                //this.AllCustomerCount();
            }
        } catch (e) {
            console.error(e);
        }
    }

    onCompanySelect() {
        this.onChangeCompany();
        this.getAllFilteredAwbno();
    }

    onChangeCompany() {
        //if billto company then show service center
        if (this.companyList.filter(x => x.id == this.invoiceForm.get('ddlCompany').value)[0]?.billto == 'Service Center') {
            this.showServiceCenter = true;
            this.invoiceForm.get('ddlServiceCenter').setValidators([Validators.required]);
        } else {
            this.showServiceCenter = false;
            this.invoiceForm.get('ddlServiceCenter').clearValidators();
        }
        this.invoiceForm.get('ddlServiceCenter').updateValueAndValidity();
    }

    onChangeServiceCenter() {
        const serviceCenter: any = this.ServiceCenterOptions.filter((x: any) => x.id === this.invoiceForm.get('ddlServiceCenter').value);
        this.serviceCenterCountry = serviceCenter[0].location.country;
        this.serviceCenterState = serviceCenter[0].location.state;
        this.getAllFilteredAwbno();
    }

    onGridReadyCustWise(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    onGridReadyAWBWise(params: GridReadyEvent) {
        this.gridApi2 = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
        this.showDataAWBWise();
    }

    getAllServiceCenter() {
        try {
            this.serviceCenter.GetAllServiceCenters().subscribe((res) => {
                if (res && res.success) {
                    this.ServiceCenterOptions = res.data;
                } else {
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    bindVendor() {
        this.vendorService.GetAll('').subscribe((res) => {
            this.vendorList = res?.success ? res.data : [];
        })
    }

    bindService() {
        const id = this.invoiceForm.get('ddlVendor').value;
        this.invoiceForm.get('ddlVendorService').reset();
        this.vendorService.GetAllListByVendor({ id: id }).subscribe((res) => {
            if (res?.success && res.data) {
                this.serviceList = res.data;
                this.getAllFilteredAwbno();
            }
        })
    }
    onCountryChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.invoiceForm.get('ddlOriginCountry').value;
            this.invoiceForm.controls.ddlOriginState.reset();
            this.invoiceForm.controls.ddlOriginCity.reset();
            this.originCityList = [];
            this.bindStatesByCountry(countryCode, origin);
            //this.allAWBList = this.allAWBList?.filter(x => (countryCode || x.origincountry === countryCode));
        }
        else {
            countryCode = this.invoiceForm.get('ddlDestinationCountry').value;
            this.invoiceForm.controls.ddlDestinationState.reset();
            this.invoiceForm.controls.ddlDestinationCity.reset();
            this.destinationCityList = [];
            this.bindStatesByCountry(countryCode);
            //this.allAWBList = this.allAWBList?.filter(x => (countryCode || x.destinationcountry === countryCode));
        }
        this.getAllFilteredAwbno();
    }

    bindCountries() {
        try {
            this.geoService.GetAllCountries().subscribe((res) => {
                if (res && res.success) {
                    const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
                    const defaultCountryCode = metaInfo.defaultcountry;

                    if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
                        this.countryList = res.data;
                    } else if (metaInfo.operationtype.includes('Domestic')) {
                        this.countryList = res.data.filter(item => item.isocode === defaultCountryCode);
                        this.invoiceForm.get('ddlCountry').setValue(defaultCountryCode);
                        this.invoiceForm.get('ddlCountry').disable();
                        this.onCountryChange();
                    } else if (metaInfo.operationtype.includes('International')) {
                        this.countryList = res.data.filter(item => item.isocode !== defaultCountryCode);
                    } else {
                        this.countryList = res.data;
                    }
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    bindStatesByCountry(countryCode?: string, type?: any) {
        try {
            if (countryCode) {
                this.geoService.GetAllStates({ countrycode: countryCode }).subscribe((res) => {
                    if (res && res.success) {
                        this.countryCode = countryCode;
                        this[type === 'origin' ? 'originStateList' : 'destinationStateList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    onStateChange(origin?) {
        let countryCode: any;
        if (origin) {
            countryCode = this.invoiceForm.get('ddlOriginState').value;
            this.invoiceForm.controls.ddlOriginCity.reset();
            this.bindCitiesByState(countryCode, origin);
        }
        else {
            countryCode = this.invoiceForm.get('ddlDestinationState').value;
            this.invoiceForm.controls.ddlDestinationCity.reset();
            this.bindCitiesByState(countryCode);
        }
        this.getAllFilteredAwbno();
    }

    bindCitiesByState(stateCode?: string, type?: any) {
        try {
            if (stateCode) {
                this.geoService.GetAllCities({ statecode: stateCode }).subscribe((res) => {
                    if (res && res.success) {
                        this[type === 'origin' ? 'originCityList' : 'destinationCityList'] = res.data;
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

    async openWarningDialog(msg: any) {
        Swal.fire({
            // title: 'Oops!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }

    async openConfirmationDialog(msg: any, cb: any) {
        // Check if there is an API error
        const result = await Swal.fire({
            title: 'Confirmation !',
            html: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

        if (result.isConfirmed) {
            cb(true);
        } else {
            cb(false);
        }
    }

    async openSuccessDialog(msg: any) {
        // Check if there is an API error
        const result = await Swal.fire({
            // title: 'Success!',
            html: msg,
            icon: 'success',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

        if (result.isConfirmed) {
            this.router.navigate(['/invoices/sales']);
        }
    }

    formatter = (x: { name: string }) => x.name;

    search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map((term) =>
                term === ''
                    ? []
                    : this.addressBookList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
            ),
        );

    bindAddressBook() {
        try {
            this.addressbookService.GetAll().subscribe((res) => {
                if (res && res.success) {
                    this.addressBookList = res.data;
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    onSelectShipper() {
        this.getAllFilteredAwbno();
    }

    deleteAction(cell: any) {
        if (this.isLock) {
            this.appCoreService.showMessage('Can not remove AWBNumber, Due to Invoice is lock.', '', 'error');
            return;
        }
        if (this.rowDataAWBWise.length == 1) {
            this.appCoreService.showMessage('Can not remove AWBNumber, Invoice cannot be empty.', '', 'error');
            return;
        }

        this.openConfirmationDialog('<span>Are you sure you want to delete ?</span>', (confirmed: any) => {

            if (confirmed) {
                if (cell.isaddednewly) {
                    this.allAWBList = this.allAWBList.filter(x => x.awbnumber !== cell.awbnumber);
                    this.showDataAWBWise();
                    return;
                }

                try {
                    this.ngxLoaderService.start();
                    // this.invoiceService.DeleteAWBFromInvoice(cell?.awbnumber).subscribe((res) => {
                    //     if (res && !res.success) {
                    //         this.ngxLoaderService.stop();
                    //         this.appCoreService.showMessage(res?.message, '', 'error');
                    //     } else if (res && res.success) {
                    //         this.appCoreService.showMessage('Record removed successfully.');
                    //         this.getAllFilteredAwbno();
                    //     }
                    // })
                    this.invoiceService.DeleteAWBFromInvoice(cell?.awbnumber).subscribe({
                        next: (res) => {
                            if (res && !res.success) {
                                this.appCoreService.showMessage(res?.message, '', 'error');
                            } else if (res && res.success) {
                                this.appCoreService.showMessage('Record removed successfully.');
                                this.getAllFilteredAwbno();
                            }
                        },
                        error(err) {
                            this.appCoreService.showMessage('Please contact your system administrator', '', 'error');
                        },
                        complete: () => {
                            this.ngxLoaderService.stop();
                        }
                    });
                } catch (error) {

                }
            }
        });
    }

    updateInvoice(): void {
        try {
            let reqObj = {
                invoicedate: this.formateDate(this.invoiceForm.get('txtInvoiceDate').value).dateString,
                invoiceid: this.invoiceId,
                awbList: this.allAWBList.map(x=> x.awbnumber),
            }

            this.ngxLoaderService.start();
            this.invoiceService.UpdateSalesInvoice(reqObj).subscribe(res => {
                if (res) {
                    if (res && res.success) {
                        this.openSuccessDialog(`Invoice <b>${res.data.invoiceno}</b> updated successfully.`);
                    }
                    this.ngxLoaderService.stop();
                }
            });
        } catch (error) {
            this.ngxLoaderService.stop();
        }
    }

    typeChange(): void {
        let type = this.awbForm.get('txtType').value;
        if (type === 'AWB') {
            this.awbForm.get('txtFromDate').reset();
            this.awbForm.get('txtToDate').reset();
        } else {
            this.awbForm.get('txtAWBNo').reset();
        }
    }

    addAWB(): void {
        try {
            this.isAWBFormSubmitted = true;
            if (this.awbForm.valid) {

                let reqObj = {
                    invoiceid: this.invoiceId,
                    mode: 'addawb',
                    awbnumber: this.awbForm.get('txtAWBNo').value,
                    fromdate: this.awbForm.get('txtFromDate').value ? this.formateDate(this.awbForm.get('txtFromDate').value).dateString : null,
                    todate: this.awbForm.get('txtToDate').value ? this.formateDate(this.awbForm.get('txtToDate').value).dateString : null,
                    customerid: this.invoiceForm.get('ddlCustomer').value
                }
                this.ngxLoaderService.start();
                this.invoiceService.GetAWBListByInvoiceId(reqObj).subscribe((res) => {
                    if (res) {
                        if (res.success && res?.data?.length) {
                            this.awbForm.get('txtType').setValue('AWB');
                            this.awbForm.get('txtAWBNo').reset();
                            this.awbForm.get('txtFromDate').reset();
                            this.awbForm.get('txtToDate').reset();

                            let awbList = res.data;
                            awbList = awbList.filter((awb) => !this.allAWBList.some(existingAwb => existingAwb.awbnumber === awb.awbnumber));
                            awbList = awbList.map((x) => ({ ...x, isaddednewly: true }));


                            // let filteredCust: any[] = [];

                            // awbList.filter((a, i) => awbList.findIndex((s) => a.customerid === s.customerid) === i).map((x) => {
                            //     filteredCust.push({
                            //         id: x.customerid,
                            //         name: x.customername
                            //     });
                            // });
                            let filteredCust: any[] = [];
                            this.allAWBList = this.allAWBList.concat(awbList);

                            this.allAWBList.filter((a, i) => this.allAWBList.findIndex((s) => a.customerid === s.customerid) === i).map((x) => {
                                filteredCust.push({
                                    id: x.customerid,
                                    name: x.customername
                                });
                            });
                            //console.log("filteredCust", filteredCust);
                            this.filteredCustomer = [...filteredCust];
                            if (this.filteredCustomer.length) {
                                this.invoiceForm.get('txtCustomer').setValue(this.filteredCustomer[0].name);
                                this.showDataAWBWise();
                            }

                            // if (this.allAWBList?.length) {
                            //     this.showDataAWBWise();
                            // }
                        } else {
                            this.toastr.info('No airwayBils found for the selected criteria.', 'Info');
                        }
                        this.ngxLoaderService.stop();
                    }
                });
            }
        } catch (e) {
            this.ngxLoaderService.stop();
            console.log(e);
        }
    }

    onRowSelected() {
        let req = this.gridOptions.api.getSelectedRows();
        this.areSelected = req?.length > 0 ? true : false;
    }

    // public isRowSelectable: IsRowSelectable = (
    //     params: any,
    //   ) => {
    //     // console.log('params', params);
    //     return params.data.isaddednewly !== true;
    //   };

}
